import React, { useState } from "react";
import { userApi, apiError } from "@/lib/userApi";
import { toast } from "sonner";
import { ShieldAlert, Eye } from "lucide-react";
import { GlassButton } from "@/components/GlassBits";

/** Términos + aviso de privacidad con casilla obligatoria antes de entrar. */
export const TermsGate = ({ onAccepted }) => {
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);

  const accept = async () => {
    if (!checked) return toast.error("Debes aceptar los términos para entrar");
    setBusy(true);
    try {
      await userApi.post("/community/join", { accept_terms: true });
      onAccepted();
    } catch (e) {
      toast.error(apiError(e, "No se pudo entrar a la comunidad"));
      setBusy(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto glass-card p-7" data-testid="community-terms">
      <div className="flex items-center gap-2 text-white font-semibold mb-3">
        <ShieldAlert className="w-5 h-5 text-red-400" /> Términos y Aviso de Privacidad
      </div>
      <div className="space-y-3 text-sm text-white/70 max-h-72 overflow-y-auto pr-2">
        <p>Al entrar a la comunidad aceptas tratar con respeto a los demás miembros y no usar
          el espacio para fraudes, suplantación de identidad ni venta de artículos ilegales.</p>
        <div className="glass-card p-4 border-red-500/30">
          <div className="flex items-center gap-2 text-red-300 font-semibold mb-1">
            <Eye className="w-4 h-4" /> Revisión de conversaciones
          </div>
          <p className="text-white/75">
            Por seguridad y prevención de fraude, el administrador puede revisar cualquier
            conversación (privada, de grupo o de canal), incluidos mensajes, imágenes y audios.
            Cada acceso del administrador queda registrado en una auditoría con quién, cuándo
            y qué conversación consultó.
          </p>
        </div>
        <p>Tus datos (nombre, foto, biografía y correo) se usan solo para identificarte dentro
          de la comunidad. Puedes pedir la eliminación de tu cuenta en cualquier momento.</p>
      </div>

      <label className="flex items-start gap-3 mt-5 cursor-pointer">
        <input type="checkbox" data-testid="terms-checkbox" checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
          className="mt-1 w-4 h-4 accent-red-500" />
        <span className="text-sm text-white/80">
          He leído y acepto los términos y el aviso de privacidad, incluida la revisión de
          conversaciones por parte del administrador.
        </span>
      </label>

      <GlassButton tone="red" className="mt-5" data-testid="terms-accept-btn" loading={busy}
        onClick={accept}>Entrar a la comunidad</GlassButton>
    </div>
  );
};

export default TermsGate;
